import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

// 開始は1本。分かれたあとは隣どうしで2本合流する。
export const MAP_NODES_DEEP: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["d1"], x: 2, y: 0 }),
  d1: caseNode("d1", ["d2"], 2, 1),
  d2: caseNode("d2", ["rest-d-open"], 2, 2),
  "rest-d-open": restNode("rest-d-open", ["d3-l", "d3-r"], 2, 3),

  "d3-l": caseNode("d3-l", ["d4-l", "d-mid"], 1, 4),
  "d3-r": caseNode("d3-r", ["d-mid", "d3s-r"], 3, 4),
  "d4-l": caseNode("d4-l", ["d5-l", "d-lc"], 0, 5),
  "d-mid": caseNode("d-mid", ["d-lc", "d-cr"], 2, 5),
  "d3s-r": caseNode("d3s-r", ["d-cr", "d4-r"], 4, 5),
  "d5-l": caseNode("d5-l", ["rest-d-l"], 0, 6),
  "d-lc": caseNode("d-lc", ["rest-d-l"], 1, 6),
  "d-cr": caseNode("d-cr", ["rest-d-r"], 3, 6),
  "d4-r": caseNode("d4-r", ["rest-d-r", "d5-r"], 4, 6),

  "rest-d-l": restNode("rest-d-l", ["d6-l", "d-join"], 1, 7),
  "rest-d-r": restNode("rest-d-r", ["d-join", "d-detour", "d5-r"], 3, 7),
  "d6-l": caseNode("d6-l", ["d7-l"], 1, 8),
  "d-join": caseNode("d-join", ["d7-l", "d5-r-b"], 2, 8),
  "d-detour": caseNode("d-detour", ["d5-r-b"], 3, 8),
  "d5-r": caseNode("d5-r", ["rest-d-r2"], 4, 8),
  "d7-l": caseNode("d7-l", ["d8-l", "rest-d-l2"], 1, 9),
  "d5-r-b": caseNode("d5-r-b", ["d6-r"], 3, 9),
  "d8-l": caseNode("d8-l", ["rest-d-l2"], 1, 10),
  "d6-r": caseNode("d6-r", ["rest-d-r2"], 3, 10),

  "rest-d-l2": restNode("rest-d-l2", ["d-pre-l"], 2, 11),
  "rest-d-r2": restNode("rest-d-r2", ["d-pre-r"], 4, 11),
  "d-pre-l": caseNode("d-pre-l", ["rest-d-pre"], 1, 12),
  "d-pre-r": caseNode("d-pre-r", ["rest-d-pre"], 3, 12),
  "rest-d-pre": restNode("rest-d-pre", ["boss"], 2, 13),
  boss: node("boss", { kind: "case", caseId: "deep-boss", next: [], x: 2, y: 14 }),
};
